import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  list: {},
  filterInputValues: {
    project: {},
  },
};

export const contractsSlice = createSlice({
  name: "contracts",
  initialState,
  reducers: {
    reducerGetCoefficientList: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      const temp: any = {};
      if (action.payload.data) {
        action.payload.data.map(
          (el: any) =>
            (temp[el.contract.id] = temp[el.contract.id]
              ? [...temp[el.contract.id], el]
              : [el])
        );
      }
      state.list = temp;
    },
    reducerSetRequestStatus: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.requestStatus = action.payload;
    },
  },
});

export const { reducerGetCoefficientList, reducerSetRequestStatus } =
  contractsSlice.actions;

export default contractsSlice.reducer;
